/**
 * Share (or copy) a Wordle result. On web prefers the clipboard (no native share sheet); on native uses
 * the OS share sheet. Returns how it resolved so the caller can show the right confirmation.
 */
import { Platform, Share } from 'react-native';

export async function shareResult(message: string): Promise<'shared' | 'copied' | 'failed'> {
  try {
    if (Platform.OS === 'web') {
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(message);
        return 'copied';
      }
    }
    await Share.share({ message });
    return 'shared';
  } catch {
    return 'failed';
  }
}
